const CREATE_FARM_PLOT_RESPONSE = {
  FarmPlot: 'FarmPlot',
  TokenError: 'TokenError',
  NameAlreadyTaken: 'NameAlreadyTaken',
};

export default CREATE_FARM_PLOT_RESPONSE;
